import {
  CreateTourAccommodation,
  CreateTourService,
  TourAccommodation,
  TourDay,
  TourService,
} from "@/models";
import { LazyOperationEntity } from "@/models/commons";
import { Context, createContext, useContext } from "react";

export interface Day {
  tourDay: LazyOperationEntity<TourDay>;
  services: LazyOperationEntity<TourService>[];
  accommodations: LazyOperationEntity<TourAccommodation>[];
}

interface TourDayContext {
  days: Day[];

  reorderDays: (daysOrder: number[]) => void;
  addNewDay: () => void;
  deleteDay: (day: number) => void;
  updateDayName: (day: number, name: string) => void;

  reorderServices: (day: number, servicesOrder: number[]) => void;
  addNewService: (day: number, tourService: CreateTourService) => void;
  updateService: (day: number, tourService: TourService) => void;
  deleteService: (day: number, tourServiceId: string) => void;

  reorderAccommodations: (day: number, accommodationOrder: number[]) => void;
  addNewAccommodation: (
    day: number,
    accommodation: CreateTourAccommodation,
  ) => void;
  updateAccommodation: (day: number, accommodation: TourAccommodation) => void;
  deleteAccommodation: (day: number, accommodationId: string) => void;
}

const initialValue: TourDayContext = {
  days: [],
  addNewDay: () => {},
  reorderDays: () => {},
  deleteDay: () => {},
  updateDayName: () => {},
  reorderServices: () => {},
  addNewService: () => {},
  updateService: () => {},
  deleteService: () => {},
  reorderAccommodations: () => {},
  addNewAccommodation: () => {},
  updateAccommodation: () => {},
  deleteAccommodation: () => {},
};

export const TourDayContextProvider = createContext(
  initialValue,
) as Context<TourDayContext>;

export function useTourDaysContext() {
  return useContext<TourDayContext>(TourDayContextProvider);
}
